import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { USE_CASES, REGISTER_URL } from "@/data/site";

export default function UseCases() {
  return (
    <div data-testid="usecases-page">
      <PageHero
        overline="Who It's For"
        titleLines={["Made for every", "kind of institute."]}
        subtitle="If you teach a skill on a schedule, Activity Hub Manager was built for you. One platform, endless disciplines."
      />

      <section className="mx-auto max-w-7xl px-5 pb-24 lg:px-8">
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {USE_CASES.map((u, i) => (
            <Reveal key={u.title} delay={(i % 3) * 0.08}>
              <div className="group h-full overflow-hidden rounded-xl border border-zinc-800 bg-surface transition-all duration-300 hover:-translate-y-1 hover:border-brand/70">
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img src={u.img} alt={u.title} loading="lazy" className="h-full w-full object-cover grayscale transition-all duration-500 group-hover:scale-105 group-hover:grayscale-0" />
                  <div className="absolute inset-0 bg-gradient-to-t from-surface via-surface/30 to-transparent" />
                  <div className="absolute left-4 top-4 flex h-10 w-10 items-center justify-center rounded-md border border-white/10 bg-black/60 text-brand backdrop-blur">
                    <u.icon className="h-5 w-5" />
                  </div>
                </div>
                <div className="p-7">
                  <h3 className="font-heading text-lg font-semibold text-white">{u.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-zinc-400">{u.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-16 text-center">
          <p className="mx-auto max-w-2xl text-zinc-400">
            Don't see your category? Select multiple activities per institution — or add unlimited
            custom ones like <span className="text-white">Abacus</span>. Activity Hub adapts to any
            schedule-based institution, and supports many institutions on one platform with fully
            isolated data.
          </p>
          <a href={REGISTER_URL} data-testid="usecases-cta-btn" className="mt-6 inline-flex items-center gap-2 rounded-md bg-brand px-6 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-brand-hover">
            Get Started <ArrowRight className="h-4 w-4" />
          </a>
        </Reveal>
      </section>
    </div>
  );
}
